import { ENABLE_CONSUMER_MODE } from "@faire/deprecated-retailer-visitor-shared/lib/consts";
import { SignUpType } from "@faire/deprecated-retailer-visitor-shared/lib/popSignUp";
import { ProductPagePaths } from "@faire/deprecated-retailer-visitor-shared/paths/ProductPage";
import { Storage } from "@faire/web/common/Storage";
import { isPrerender } from "@faire/web/common/user-agent/isPrerender";
import qs from "query-string";

import { IProductLinkProps } from "../features/MarketplaceItems/ProductTile/types";

export interface IGenerateProductSignUpUrlProps {
  productToken: string | undefined;
  brandToken: string | undefined;
  location: { pathname: string; search: string };
  productOptionToken?: string | undefined;
  isShowRefB?: boolean;
  refF?: string[];
  refC?: string | undefined;
}

export const generateProductLinkPropsForLoggedOutRetailer = ({
  productToken,
  brandToken,
  productOptionToken,
  isShowRefB,
  refF,
  refC,
  location,
}: IGenerateProductSignUpUrlProps): IProductLinkProps | undefined => {
  if (!productToken) {
    return undefined;
  }
  const productPageLink = ProductPagePaths.index(productToken);
  const isConsumerMode =
    Storage.session.getItem(ENABLE_CONSUMER_MODE) === "true";
  if (isPrerender() || isConsumerMode) {
    return { productUrl: productPageLink };
  }

  const signUpUrl = `${location.pathname}?${qs.stringify({
    ...qs.parse(location.search),
    signUp: SignUpType.PRODUCT,
    brand: brandToken,
    product: productToken,
    productOptionToken: productOptionToken,
    refB: isShowRefB ? brandToken : undefined,
    refC,
    refF,
  })}`;

  // When the product tile links to the signUpUrl, it opens a signup modal over the current page
  // by modifying the current path to append a signUp param. In this case we want to use history.replace
  // instead of history.push so that page navigatino remains intuitive.
  return {
    productUrl: signUpUrl,
    replace: true,
  };
};
